type TCapitalizeIO = string | null | undefined;

export const capitalize = (str: TCapitalizeIO): TCapitalizeIO => {
  if (!str) return str;

  return str.charAt(0).toUpperCase() + str.slice(1);
};
